var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.249 10.022a9.03 9.03 0 0 1-5.277-1.687v7.681a6.981 6.981 0 0 1-4.538 6.541 6.985 6.985 0 0 1-8.592-9.869 6.994 6.994 0 0 1 7.104-3.595v3.863c-.645-.203-1.337-.197-1.978.018s-1.198.626-1.592 1.175a3.203 3.203 0 0 0 .022 3.764 3.21 3.21 0 0 0 1.605 1.156 3.209 3.209 0 0 0 4.188-3.054V1h3.782a5.21 5.21 0 0 0 .08.953 5.25 5.25 0 0 0 2.317 3.448 5.22 5.22 0 0 0 2.88.866v3.756z"
  })));
};
export default SvgTiktok;